var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.breadcrumbs),function(breadcrumb,idx){return _c('li',{key:idx,staticClass:"breadcrumb-item",class:{ active: !breadcrumb.link }},[(breadcrumb.link)?[_c('router-link',{attrs:{"to":breadcrumb.link,"title":breadcrumb.name}},[_vm._v(_vm._s(breadcrumb.name))])]:[_vm._v(" "+_vm._s(breadcrumb.name))]],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }